import { addSymbol } from 'virtual:svg-sprite-runtime'
const id = "icon_dropdown"
const viewBox = "0 0 25 25"
addSymbol(id, "<path d=\"M8.62944 11.0812C8.15667 10.4194 8.6298 9.5 9.44317 9.5H15.5568C16.3702 9.5 16.8433 10.4194 16.3705 11.0812L13.3137 15.3608C12.9149 15.9191 12.0851 15.9191 11.6862 15.3608L8.62944 11.0812Z\" fill=\"#373CF5\"/>", viewBox)
export default { id, viewBox }